// extracted by mini-css-extract-plugin
export default {"container":"Separator_container__+svCA"};